export const CELL_MOVING_BORDER_WIDTH = 2;
export const CELL_MOVING_INVALID_ALPHA = 0.3;
